import { Component, Inject, Input, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { environment } from '../../../environment';
import { IAuthenticationService } from '../../../services/interfaces/IAuthenticationService';
import { MapService } from '../../../services/map.service';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-map-picker',
    templateUrl: './map-picker.component.html',
    styleUrls: ['../../sharedStyles/base.scss', './map-picker.component.scss']
})
export class MapPickerComponent extends BaseComponent implements OnInit {
    @Input() applicationId = environment.appId;
    @Input() config: any;
    @Input() map: any;

    categories: Set<string>;
    maps: any[];
    filteredMaps: any[];

    private _category: string;

    set category(value: string) {
        this._category = value;
        this.filterMaps(value);
    }

    get category() {
        return this._category;
    }

    constructor(
        _vcr: ViewContainerRef,
        private readonly mapService: MapService,
        @Inject('authenticationService') authService: IAuthenticationService
    ) {
        super(_vcr, true);

        authService.user.subscribe(() => {
            this.loadMaps();
        });
    }

    ngOnInit() {
        this.loadMaps();
    }

    private async loadMaps() {
        try {
            const result = await this.mapService.getSystemMaps(this.applicationId, false);
            this.maps = result[0].maps;
            this.loadCategories();
            this.category = this.config.category;
            this.map = this.maps.find(m => m.name === this.config.map);
        } catch (error) {
            this.readyProblem(error);
        } finally {
            this.isReady();
        }
    }

    private loadCategories() {
        this.categories = new Set(this.maps.map(m => m.categories).flat().map(c => c.name));
    }

    private filterMaps(category) {
        this.filteredMaps = this.maps.filter(m => m.categories.map(c => c.name).includes(category));
        this.filteredMaps.unshift({ name: '<No Starter Map>' });
        this.map = this.filteredMaps[0];
    }
}
